import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { commonStyles } from '../../helpers/commonStyles';
import { useStyles } from '../../hooks/useStyles';
import { Base } from '../Base';
import { ListContext } from './List.context';
import { listStyles } from './List.styles';
import { listTheme } from './List.stylex';
import { Stack } from '../Stack';
export const List = forwardRef(function List(props, forwardedRef) {
    const { styles, sx, size, noFocusRing, children, header, footer, divider, cols = 1, ...other } = props;
    const { combineStyles, getStyles, globalStyles } = useStyles({
        name: 'List',
        styles: [listStyles, styles],
    });
    const isGrid = cols > 1;
    return (_jsx(ListContext.Provider, { value: { size, noFocusRing }, children: _jsx(Base, { ...other, sx: [listTheme, globalStyles, combineStyles('host'), sx], ref: forwardedRef, children: _jsxs(Stack, { sx: combineStyles('inner'), children: [_jsx("div", { ...getStyles('header'), children: header }), _jsx(Stack, { divider: divider, sx: combineStyles('content', isGrid && 'content$grid', isGrid &&
                            commonStyles.gridTemplateColumns(`repeat(${cols}, 1fr)`), !children && 'content$empty'), children: children }), _jsx("div", { ...getStyles('footer'), children: footer })] }) }) }));
});
